import { render, staticRenderFns } from "./DefaultOLCEditInput.vue?vue&type=template&id=ddb94d74&lang=pug&"
import script from "./DefaultOLCEditInput.vue?vue&type=script&lang=ts&"
export * from "./DefaultOLCEditInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports